<template>
  <div style="background-color: #ffffff !important;">
    <section class="mobile">
      <div class="wrapper m-collapse-wrapper">
        <div
          class="collapse-container container"
          v-bind:class="{deleteBorder: isFirstDropDownActive}"
        >
          <span class="bold">About</span>
          <span
            class="dropdown-footer"
            @click="toggleCollapse('I/O')"
            v-bind:class="{showDropDown: isFirstDropDownActive}"
          >
            <img style="width: 14px; height: 8px;" src="@/assets/btn-dropdown-footer.png" alt>
          </span>
        </div>
        <div class="content" v-bind:class="{open: isFirstCollapseOpen}">
          <p>
            아이오는 1, 2인 가구 살림살이에 보탬이 되는
            <br>소금 같은 서비스를 만듭니다.
          </p>
          <router-link title="About" to="/about">더 알아보기</router-link>
        </div>
        <div
          class="collapse-container container"
          v-bind:class="{deleteBorder: isSecondDropDownActive}"
        >
          <span class="bold">Info & Address</span>
          <span
            class="dropdown-footer"
            @click="toggleCollapse('Info')"
            v-bind:class="{showDropDown: isSecondDropDownActive}"
          >
            <img style="width: 14px; height: 8px;" src="@/assets/btn-dropdown-footer.png" alt>
          </span>
        </div>
        <div class="content" v-bind:class="{open: isSecondCollapseOpen}">
          <p>
            (주)아이오 | 대표자: 임남규
            <br>사업자등록번호: 257-81-00115
            <br>통신판매업신고: 2019-서울광진-0440
            <br>
            <br>
          <router-link :to="{ name: 'Terms' }">개인 정보 보호 & 서비스 이용 약관</router-link>
          </p>
          <p>서울시 광진구 천호대로 571 602호 아이오(04929)</p>
        </div>
      </div>
      <div class="wrapper m-contact-wrapper">
        <h3 class="bold">Contact</h3>
        <p class="contact-number-email">
          <a href="tel:02-6212-9272">02-6212-9272</a> |
          <a href="mailto:help@switcher.co.kr">help@switcher.co.kr</a>
          <br>MON-THU 10:00 ~ 18:00
        </p>
        <nav class="sns">
          <a href="https://www.facebook.com/switcher.io/" target="_blank">
            <img src="@/assets/footer/facebook.png" alt>
          </a>
          <a href="https://www.instagram.com/smarthome_io/" target="_blank">
            <img src="@/assets/footer/instagram.png" alt>
          </a>
          <a href="https://cafe.naver.com/switcherofio" target="_blank">
            <img src="@/assets/footer/naver-cafe.png" alt>
          </a>
          <a href="https://pf.kakao.com/_uuXmV" target="_blank">
            <img src="@/assets/footer/kakao-talk.png" alt>
          </a>
        </nav>
        <span class="copy-right">Copyright 2020 I/O inc. All rights Reserved</span>
      </div>
    </section>
    <section class="desktop">
      <nav class="footerA">
        <div>
          <h3>About</h3>
          <p>
            아이오는 1, 2인 가구 살림살이에 보탬이 되는
            <br>소금 같은 서비스를 만듭니다.
          </p>
          <router-link style="display: block; margin-top: 37px;" title="About" to="/about">더 알아보기</router-link>
        </div>
        <div>
          <h3>Info</h3>
          <p>(주)아이오 | 대표자: 임남규</p>
          <p>사업자등록번호: 257-81-00115</p>
          <p>통신판매업신고: 2019-서울광진-0440</p>
          <div style="margin-top: 16px">
            <router-link :to="{ name: 'Terms' }">개인 정보 보호 & 서비스 이용 약관</router-link>
          </div>
        </div>
        <div>
          <h3>Address</h3>
          <p>서울시 광진구 천호대로 571 </p>
          <p>602호 아이오</p>
        </div>
        <div>
          <h3>Contact</h3>
          <p>
            <a href="tel:02-6212-9272">02-6212-9272</a>
          </p>
          <p>
            <a href="mailto:help@switcher.co.kr">help@switcher.co.kr</a>
          </p>
          <p>MON-THU 10:00 ~ 18:00</p>
          <p>LUNCH 12:30~13:30</p>
        </div>
      </nav>
      <nav class="footerB">
        <i class="io-logo">
          <img style="width: 35px; height: 20px;" src="@/assets/header/io-logo.png" alt>
        </i>
        <div class="sns">
          <a href="https://www.facebook.com/switcher.io/" target="_blank">
            <img src="@/assets/footer/facebook.png" alt>
          </a>
          <a href="https://www.instagram.com/smarthome_io/" target="_blank">
            <img src="@/assets/footer/instagram.png" alt>
          </a>
          <a href="https://cafe.naver.com/switcherofio" target="_blank">
            <img src="@/assets/footer/naver-cafe.png" alt>
          </a>
          <a href="https://pf.kakao.com/_uuXmV" target="_blank">
            <img src="@/assets/footer/kakao-talk.png" alt>
          </a>
        </div>
        <span class="copy-right">Copyright 2021 I/O inc. All rights Reserved</span>
      </nav>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'app-footer',
    data () {
      return {
        isFirstCollapseOpen: false,
        isSecondCollapseOpen: false,
        isFirstDropDownActive: false,
        isSecondDropDownActive: false
      }
    },
    methods: {
      toggleCollapse: function (division) {
        switch (division) {
          case 'I/O':
            this.isFirstDropDownActive = !this.isFirstDropDownActive
            this.isFirstCollapseOpen = !this.isFirstCollapseOpen
            break
          case 'Info':
            this.isSecondDropDownActive = !this.isSecondDropDownActive
            this.isSecondCollapseOpen = !this.isSecondCollapseOpen
            break
        }
      }
    }
  }
</script>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
ul {
  list-style: none;
  display: flex;
  padding: 0;
}
ul li {
  padding: 10px;
}

.container .collapse-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.container .sns {
  display: flex;
  justify-content: center;
}

.content {
  font-size: 12px;
  line-height: 20px;
  padding: 0px 30px 30px 30px;
  display: none;
  overflow: hidden;
  text-align: left;
}

.content a {
  text-decoration: underline !important;
  color: #3d4953;
}
.sns img {
  width: 26px;
  height: 26px;
}

.open {
  display: block;
  border-bottom: 0.1px solid silver;
}

.footerA {
  display: flex;
  justify-content: space-around;
  padding: 45px 200px 40px 200px;
  margin-bottom: 100px;
}

.footerA div {
  text-align: left;
  font-size: 14px;
  line-height: 1.57;
  letter-spacing: 0;
  /* flex: 1; */
}

.footerA a {
  text-decoration: underline !important;
  margin-top: 16px;
  color: #3d4953;
}

.footerA h3 {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  margin-bottom: 13px;
}

.footerA p {
  margin: 0;
  line-height: 1.57;
  text-decoration: none !important;
}

.footerA p a {
  text-decoration: none !important;
}
.footerB {
  padding: 15px;
  display: flex;
  align-items: center;
  border-top: solid 1px #dee2e5;
}

.footerB :nth-child(1) {
  flex: 2;
}
.footerB :nth-child(2) {
  flex: 3;
}
.footerB :nth-child(2) img {
  margin-right: 30px;
}
.footerB :nth-child(3) {
  flex: 2;
}

.m-collapse-wrapper .container {
  justify-content: space-between;
  padding: 30px;
  border-bottom: 0.1px solid silver;
}
.m-collapse-wrapper span {
  font-size: 14px;
}

.m-contact-wrapper {
  margin-top: 25px;
  padding-bottom: 60px;
}
.m-contact-wrapper .sns {
  padding: 20px 40px 20px 40px;
  display: flex;
  justify-content: space-around;
}

.m-contact-wrapper h3 {
  font-size: 14px;
}

.copy-right {
  font-size: 10px;
}
.contact-number-email {
  font-size: 12px;
}
.contact-number-email a {
  color: #3d4953 !important;
  text-decoration: none;
}

.dropdown-footer {
  transition: 0.5s;
}

.deleteBorder {
  border: 0 !important;
}

.showDropDown {
  -webkit-transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue